import { ReturnProduct } from "@redotech/redo-model/draft-return/draft-return-items";
import { CurrencyContext } from "@redotech/redo-web/currency";
import { memo, useContext } from "react";
import * as product from "./product.module.css";

export const Product = memo(function Product({
  returnProduct,
  expandedButNotUnbundled,
}: {
  returnProduct: ReturnProduct;
  expandedButNotUnbundled?: boolean;
}) {
  const { formatCurrency } = useContext(CurrencyContext);

  if (expandedButNotUnbundled) {
    return (
      <div>
        <div>
          <div className={product.bundleSubtext}>
            {returnProduct.title} - {returnProduct.variantTitle}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={product.productsContainer}>
      <div className={product.content}>
        {returnProduct.image && (
          <img
            alt={returnProduct.variantData?.variants?.[0]?.title || ""}
            className={product.productImage}
            src={returnProduct.image}
          />
        )}
        <div className={product.productInfoWrapper}>
          <div className={product.productInfo}>
            <div>
              <div className={product.productTitle}>{returnProduct.title}</div>
              <div className={product.price}>
                {formatCurrency(returnProduct.returnValue)}
              </div>
            </div>
            {!!returnProduct.variantTitle &&
              returnProduct.variantTitle !== "Default Title" && (
                <div className={product.variantTitle}>
                  {returnProduct.variantTitle.replaceAll("/", " | ")}
                </div>
              )}
          </div>
        </div>
      </div>
    </div>
  );
});
